import { IconAddPhotoAlternate } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'

export function FileDropzone({
  isDragging,
  setIsDragging,
  handleDrop,
  triggerUpload,
  isError,
}: {
  isDragging: boolean
  setIsDragging: (isDragging: boolean) => void
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void
  triggerUpload: () => void
  isError?: boolean
}) {
  return (
    <div
      onClick={triggerUpload}
      onDragOver={e => {
        e.preventDefault()
        setIsDragging(true)
      }}
      data-testid="post-project-dialog-dropzone"
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
      className={tw(
        `w-full p-4 mt-2 rounded-2 border border-dashed flex flex-col
        justify-center items-center text-center cursor-pointer transition-colors
        h-[134px] bg-cf-grey-50 hover:bg-cf-grey-100`,
        // oxlint-disable-next-line no-nested-ternary
        isDragging
          ? 'bg-cf-grey-50 border-[#13131585]'
          : isError
            ? 'border-cf-red-900'
            : ' border-[#1313151F]',
      )}
    >
      <IconAddPhotoAlternate className="text-cf-purple-900 !size-6 mb-2.5" />
      <p className="text-12 text-cf-grey-600 text-center">
        Drag and drop image or video or click here to browse.
        <br />
        You can add <b>up to 10 uploads</b>.
      </p>
    </div>
  )
}
